/**
 * Header language switcher toggle.
 *
 * Opens/closes the dropdown, supports outside-click and Escape-to-close,
 * and keeps aria-expanded in sync with the visible state.
 */

const initLanguageSwitcher = () => {
  const switchers = document.querySelectorAll('[data-language-switcher]');

  if (!switchers.length) {
    return;
  }

  const closeAll = (except = null) => {
    switchers.forEach((el) => {
      if (el === except) {
        return;
      }
      el.classList.remove('is-open');
      const toggle = el.querySelector('.language-switcher-toggle');
      const dropdown = el.querySelector('.language-switcher-dropdown');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
      if (dropdown) {
        dropdown.setAttribute('hidden', '');
      }
    });
  };

  switchers.forEach((switcher) => {
    const toggle = switcher.querySelector('.language-switcher-toggle');
    const dropdown = switcher.querySelector('.language-switcher-dropdown');

    if (!toggle || !dropdown) {
      return;
    }

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = switcher.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        dropdown.removeAttribute('hidden');
        closeAll(switcher);
      } else {
        dropdown.setAttribute('hidden', '');
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-language-switcher]')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
    }
  });
};

export default initLanguageSwitcher;
